import { useState } from "react"
import clsx from "clsx"

type InfoPropTypes = {
    lineHeight?: number
    isElite?: boolean
    children?: React.ReactNode
    className?: string
    lineClassName?: string
    contentClassName?: string
}

export default function Info({ lineHeight, children, className, lineClassName, contentClassName }: InfoPropTypes) {
    const [childHeight, setChildHeight] = useState(lineHeight ?? 32)

    return (
        <div className={clsx('flex gap-3 items-center', className)}>
            <div
                style={{ height: `${childHeight}px` }}
                className={clsx('h-8 w-[3px] rounded-lg opacity-95 bg-[#8E9393]', lineClassName)}
            />
            <div
                ref={(ref) => {
                    if (ref && !lineHeight) setChildHeight(() => ref?.clientHeight - 8 || 32)
                }}
                className={clsx('leading-[150%] text-[13px] flex-1', contentClassName)}
            >
                {children}
            </div>
        </div>
    )
}